/* eslint-disable */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
// chakra imports
import { Box, Flex, HStack, Text, useColorModeValue, Image } from "@chakra-ui/react";
import { usePermissions } from "../../../hooks/usePermissions";

// Import des icônes de navigation
import tableaudebordIcon from "assets/nav-icon/tableaudebord.png";
import avisIcon from "assets/nav-icon/avis.png";
import clientIcon from "assets/nav-icon/client.png";
import missionsIcon from "assets/nav-icon/missions.png";
import vehiculeIcon from "assets/nav-icon/vehicule.png";
import materielsIcon from "assets/nav-icon/materiels.png";
import staffIcon from "assets/nav-icon/staff.png";
import ptientsIcon from "assets/nav-icon/ptients.png";
import adherentIcon from "assets/nav-icon/adherent.png";
import profileIcon from "assets/nav-icon/profile.png";
import walletIcon from "assets/nav-icon/wallet.png";
import gpsIcon from "assets/nav-icon/gps.png";
import analyseIcon from "assets/nav-icon/analyse.png";
import roleIcon from "assets/nav-icon/role.png";
import pointageIcon from "assets/nav-icon/pointage.png";
import reclamationIcon from "assets/img/icons/Reclamation/reclamation-dassurance.png";
// Mapping des icônes
const iconMap = {
  'tableaudebord.png': tableaudebordIcon,
  'avis.png': avisIcon,
  'client.png': clientIcon,
  'missions.png': missionsIcon,
  'vehicule.png': vehiculeIcon,
  'materiels.png': materielsIcon,
  'staff.png': staffIcon,
  'ptients.png': ptientsIcon,
  'adherent.png': adherentIcon,
  'profile.png': profileIcon,
  'wallet.png': walletIcon,
  'gps.png': gpsIcon,
  'analyse.png': analyseIcon,
  'role.png': roleIcon,
  'pointage.png': pointageIcon,
  'stock.png': materielsIcon,
  'reclamation-dassurance.png': reclamationIcon,
};

export function SidebarLinks(props) {
  //   Chakra color mode
  let location = useLocation();
  let activeColor = "white"; // Texte blanc pour les éléments actifs
  let inactiveColor = "white"; // Texte blanc pour les éléments inactifs
  let activeIcon = "#29BACD"; // Couleur verte pour les icônes actives
  let textColor = "white"; // Texte blanc par défaut
  let brandColor = "#29BACD"; // Couleur verte pour les indicateurs actifs

  const { routes } = props;
  const { hasPermission, isAdminOrRegulator } = usePermissions();

  // Mapping des routes vers les permissions
  const routePermissions = {
    '/default': 'dashboard_view',
    '/avis': 'avis_view',
    '/dossier-regulation': 'missions_view',
    '/missions': 'missions_view',
    '/carte-gps': 'gps_view',
    '/vehicules': 'vehicules_view',
    '/materiels': 'materiels_view',
    '/utilisateurs': 'utilisateurs_view',
    '/patients': 'patients_view',
    '/adhérents': 'adherents_view',
    '/profile': 'profile_view',
    '/wallet': 'profile_view',
    '/analyses': 'analyses_view',
    '/reclamations': 'reclamations_view',
    '/pointage-suivi': 'pointage_view',
    '/gestion-stock': 'stock_view',
    '/logs': 'logs_view'
  };

  // Fonction pour vérifier si une route est accessible
  const isRouteAccessible = (route) => {
    // Si c'est une catégorie, vérifier les sous-routes
    if (route.category) {
      return route.items.some(item => !item.hidden && isRouteAccessible(item));
    }

    // Si c'est une route admin
    if (route.layout === "/admin" || route.layout === "/rtl") {
      const permission = routePermissions[route.path];

      // Si pas de permission définie, autoriser (pour les routes publiques)
      if (!permission) return true;

      // Vérifier la permission
      return hasPermission(permission);
    }

    // Si c'est une route médecin, on l'affiche (elles sont déjà filtrées)
    if (route.layout === "/medecin") {
      return true;
    }

    return true;
  };

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  // this function creates the links from the secondary accordions (for example auth -> sign-in -> default)
  const createLinks = (routes) => {
    // Filtrer les routes visibles pour déterminer la première catégorie
    const visibleRoutes = routes.filter((route) => {
      if (route.hidden) return false;
      return isRouteAccessible(route);
    });

    let isFirstCategory = true;

    return routes.map((route, index) => {
      // Masquer les routes avec hidden: true
      if (route.hidden) {
        return null;
      }

      // Vérifier si la route est accessible avant de l'afficher
      if (!isRouteAccessible(route)) {
        return null;
      }

      if (route.category) {
        const shouldShowSeparator = !isFirstCategory;
        const isFinancierCategory = route.name === 'Gestion financiére';
        isFirstCategory = false;

        return (
          <Box key={index} w="100%" mb="8px">
            {shouldShowSeparator && (
              <Box
                w="100%"
                h="1px"
                bg="rgba(255, 255, 255, 0.2)"
                mb="16px"
                mt="8px"
              />
            )}
            <Text
              fontSize="11px"
              color="rgba(255, 255, 255, 0.6)"
              fontWeight="600"
              textTransform="uppercase"
              letterSpacing="0.5px"
              ps={{
                sm: "12px",
                xl: "16px",
              }}

              pb="8px"
              mb="4px">
              {route.name}
            </Text>
            <Box
              w="100%"
              ps={{
                sm: "12px",
                xl: "16px",
              }}>
              {createLinks(route.items)}
            </Box>
            {isFinancierCategory && (
              <Box
                w="100%"
                h="1px"
                bg="rgba(255, 255, 255, 0.2)"
                mt="16px"
                mb="8px"
              />
            )}
          </Box>
        );
      } else if (
        route.layout === "/admin" ||
        route.layout === "/rtl" ||
        route.layout === "/medecin"
      ) {
        const isActive = activeRoute(route.path.toLowerCase());
        return (
          <NavLink
            key={index}
            to={route.layout + route.path}
            style={{ textDecoration: 'none' }}>
            {route.icon ? (
              <Box
                bg={isActive ? "#B62B30" : "transparent"}
                borderRadius="8px"
                w="200px"
                h="34px"
                mb="4px"
                _hover={{ bg: "#B62B30" }}
                transition="all 0.2s"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                px="12px">
                <HStack
                  spacing="12px"
                  w="100%">
                  <Box
                    w="20px"
                    h="20px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center">
                    {typeof route.icon === 'string' ? (
                      <Image
                        src={iconMap[route.icon]}
                        alt={route.name}
                        w="20px"
                        h="20px"
                        objectFit="contain"
                        filter="brightness(0) invert(1)"
                      />
                    ) : (
                      route.icon
                    )}
                  </Box>
                  <Text
                    color="white"
                    fontWeight={isActive ? "bold" : "normal"}
                    fontSize="14px"
                    flex="1">
                    {route.name}
                  </Text>
                </HStack>
              </Box>
            ) : (
              <Box
                bg={isActive ? "#B62B30" : "transparent"}
                borderRadius="8px"
                w="200px"
                h="34px"
                mb="4px"
                _hover={{ bg: "#B62B30" }}
                transition="all 0.2s"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
                px="12px">
                <Text
                  color="white"
                  fontWeight={isActive ? "bold" : "normal"}
                  fontSize="14px">
                  {route.name}
                </Text>
              </Box>
            )}
          </NavLink>
        );
      }
    }).filter(Boolean); // Filtrer les éléments null
  };
  //  BRAND
  return createLinks(routes);
}

export default SidebarLinks;
